import { create, type StateCreator } from "zustand"

interface UseIdleDialogState {
  isOpen: boolean
  openDialog: () => void
  closeDialog: () => void
}

const state: StateCreator<UseIdleDialogState> = (set) => ({
  isOpen: false,
  openDialog: () => {
    set({ isOpen: true })
  },
  closeDialog: () => {
    set({ isOpen: false })
  },
})

export const useIdleDialog = create<UseIdleDialogState>()(state)
